import { AddBahasaPayload, EditBahasaPayload } from "../../../../models/Bahasa";
import { EditRiwayatPekerjaanPayload } from "../../../../models/RiwayatPekerjaan";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allBahasaKey } from "../../queries/Bahasa/useFetchAllBahasa";
import { allRiwayatPekerjaanKey } from "../../queries/RiwayatPekerjaan/useFetchAllRiwayatPekerjaan";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function editRiwayatPekerjaan(data: EditRiwayatPekerjaanPayload) {
  const res = await ApiClient.put(`/EditPekerjaan`, data);
  return res.data;
}

export const useEditRiwayatPekerjaan = mutationWrapper(editRiwayatPekerjaan, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allRiwayatPekerjaanKey);
  },
});
